export default __webpack_public_path__ + "static/media/img-11.4bac8b6f.jpg";